import React from "react";
import Badge from "../Components/Badge";
import PeopleRowActionsMenu from "./PeopleRowActionsMenu";
import { stateBadgeVariant } from "../utils/userStateBadge";

export function buildPeopleDirectoryColumns({
  canEdit = false,
  onEditPerson,
} = {}) {
  return [
    {
      accessorKey: "full_name",
      header: "Name",
      cell: ({ row }) => (
        <a href={`/people/${row.original.id}`} className="link-row">
          {row.original.full_name}
        </a>
      ),
      filterFn: "includesString",
    },
    {
      accessorKey: "email",
      header: "Email",
      filterFn: "includesString",
    },
    {
      accessorKey: "department_label",
      header: "Department",
      filterFn: "includesString",
      cell: ({ getValue }) => getValue() || "—",
    },
    {
      accessorKey: "account_type_label",
      header: "Support",
      filterFn: "includesString",
      cell: ({ getValue }) => getValue() || "—",
    },
    {
      accessorKey: "portal_role_label",
      header: "Portal Role",
      filterFn: "includesString",
    },
    {
      accessorKey: "start_date",
      header: "Start date",
      filterFn: "includesString",
      cell: ({ getValue }) => getValue() || "—",
    },
    {
      accessorKey: "end_date",
      header: "End date",
      filterFn: "includesString",
      cell: ({ getValue }) => getValue() || "—",
    },
    {
      accessorKey: "state",
      header: "Status",
      // Exact match from a dropdown: a substring filter on "Active" also matches "Inactive".
      filterFn: "equalsString",
      meta: { filterVariant: "select" },
      cell: ({ getValue }) => (
        <Badge variant={stateBadgeVariant(getValue())}>{getValue()}</Badge>
      ),
    },
    {
      id: "actions",
      header: () => <span className="sr-only">Actions</span>,
      enableSorting: false,
      enableColumnFilter: false,
      cell: ({ row }) => (
        <PeopleRowActionsMenu
          person={row.original}
          canEdit={canEdit}
          onEditPerson={onEditPerson}
        />
      ),
    },
  ];
}
